import { ServiceException as __ServiceException, } from "@smithy/smithy-client";
export { __ServiceException };
export class Apiv2ServiceException extends __ServiceException {
    constructor(options) {
        super(options);
        Object.setPrototypeOf(this, Apiv2ServiceException.prototype);
    }
}
